// @ts-expect-error import a model from an external library
import { ErrorModel } from '@health/booking-sdk-react/dist/services/bb-booking/models'
import { pageconfigurationsApi, type partnersApi } from 'app/src/services/welfareportal/'
import { DefaultBodyType, http, HttpResponse } from 'msw'
import { apiBaseUrl } from './commonconfig'

const defaultConfig: pageconfigurationsApi.Page = [
  {
    id: 'homepage',
    jsonLogicExpression: { and: [{ '==': [{ var: 'mustJoin' }, true] }, { in: [{ var: 'phase' }, ['pre-join', 'join']] }] },
    sections: [
      {
        sectionName: 'TimerAndBalanceSection',
        renderingMode: 'native',
      },
      {
        renderingMode: 'native',
        sectionName: 'HomeHeaderSection',
        containerStyleOverrides: {
          style: {
            display: 'block',
          },
        },
      },
      {
        renderingMode: 'htmlfragment',
        sectionName: 'BenefitForecastSection',
        containerStyleOverrides: {
          style: {
            background: '#FAFAFA',
            borderBottom: '1px solid gray',
          },
        },
        parameters: {
          htmlFragmentPath: '/benefitForecast.html',
        },
      },
      {
        renderingMode: 'htmlfragment',
        sectionName: 'BenefitSimulationSection',
        parameters: {
          htmlFragmentPath: '/benefitSimulation.html',
        },
      },
      {
        renderingMode: 'native',
        sectionName: 'CatalogSummarySection',
      },
      {
        renderingMode: 'native',
        sectionName: 'WelfareDetailsSection',
      },
      {
        renderingMode: 'native',
        sectionName: 'TermsSection',
      },
      {
        renderingMode: 'native',
        sectionName: 'HomeFooterJoinSection',
      },
    ],
  },
  {
    id: 'homepage',
    jsonLogicExpression: {
      or: [{ '==': [{ var: 'mustJoin' }, false] }, { in: [{ var: 'phase' }, ['pre-fruition', 'fruition', 'closed']] }],
    },
    sections: [
      {
        sectionName: 'TimerAndBalanceSection',
        renderingMode: 'native',
      },
      {
        renderingMode: 'native',
        sectionName: 'CatalogSummarySection',
      },
      {
        renderingMode: 'native',
        sectionName: 'PartnersSection',
      },
      {
        renderingMode: 'native',
        sectionName: 'NewsCarouselSection',
      },
    ],
  },
]
const carabinieriConfig: pageconfigurationsApi.Page = [
  {
    id: 'homepage',
    jsonLogicExpression: { and: [{ '==': [{ var: 'mustJoin' }, true] }, { in: [{ var: 'phase' }, ['pre-join', 'join']] }] },
    sections: [
      {
        renderingMode: 'native',
        sectionName: 'CatalogSummarySection',
      },
      {
        renderingMode: 'native',
        sectionName: 'PartnersSection',
      },
      {
        renderingMode: 'native',
        sectionName: 'NewsCarouselSection',
      },
    ],
  },
  {
    id: 'homepage',
    jsonLogicExpression: {
      or: [{ '==': [{ var: 'mustJoin' }, false] }, { in: [{ var: 'phase' }, ['pre-fruition', 'fruition', 'closed']] }],
    },
    sections: [
      {
        renderingMode: 'native',
        sectionName: 'CatalogSummarySection',
      },
      {
        renderingMode: 'native',
        sectionName: 'PartnersSection',
      },
      {
        renderingMode: 'native',
        sectionName: 'NewsCarouselSection',
      },
    ],
  },
]
const defaultPartners = [
  {
    targetPage: 'https://www.justeat.it/',
    title: 'Just Eat',
    imageSrc: './images/just-eat.png',
    id: '1',
  },
  {
    targetPage: 'https://www.sky.it/',
    title: 'Sky',
    imageSrc: './images/sky.png',
    id: '2',
  },
  {
    targetPage: 'https://www.amazon.it/',
    title: 'Amazon',
    imageSrc: './images/amazon.png',
    id: '3',
  },
  {
    targetPage: 'https://www.ikea.it/',
    title: 'Ikea',
    imageSrc: './images/ikea.png',
    id: '4',
  },
  {
    targetPage: 'https://www.expedia.com/',
    title: 'Expedia',
    imageSrc: './images/expedia.png',
    id: '5',
  },
]

const carabinieriPartners = [
  {
    targetPage: 'https://www.samsung.com/it/',
    title: 'Samsung',
    imageSrc: './images/samsung.jpg',
    id: '6',
  },
  {
    targetPage: 'https://www.msccrociere.it/',
    title: 'MSC Crociere',
    imageSrc: './images/msc.png',
    id: '7',
  },
  {
    targetPage: 'https://www.ita-airways.com/',
    title: 'ITA Airways',
    imageSrc: './images/ita.png',
    id: '8',
  },
  {
    targetPage: 'https://www.rinascente.it/',
    title: 'RINASCENTE',
    imageSrc: './images/larinascente.png',
    id: '9',
  },
  {
    targetPage: 'https://www.autotorino.it/',
    title: 'Autotorino',
    imageSrc: './images/autotorino.jpg',
    id: '10',
  },
  {
    targetPage: 'https://www.salmoiraghievigano.it/',
    title: 'Salmoiraghi & Viganò',
    imageSrc: './images/salmoiraghi.jpg',
    id: '11',
  },
]

const getHomePageConfig = http.get<{ templateId: string }, DefaultBodyType, pageconfigurationsApi.Page>(
  apiBaseUrl + '/:templateId/pages/homepage',
  (req) => {
    const templateId = (req.params as { templateId: string }).templateId
    switch (templateId) {
      case 'DEFAULT':
        return HttpResponse.json(defaultConfig)
      case 'CARABINIERI':
        return HttpResponse.json(carabinieriConfig)
      default: {
        const result = {
          status: 404,
          type: 'urn:ConfigNotFound',
          title: 'config not found',
          rc: 42404,
        } as ErrorModel
        return HttpResponse.json(result, { status: 404 })
      }
    }
  },
)

export const getPartners = http.get<{ templateId: string }, DefaultBodyType, partnersApi.Partners>(
  apiBaseUrl + '/:templateId/pages/partners',
  (req) => {
    const templateId = (req.params as { templateId: string }).templateId
    switch (templateId) {
      case 'DEFAULT':
        return HttpResponse.json(defaultPartners)
      case 'CARABINIERI':
        return HttpResponse.json(carabinieriPartners)
      default: {
        const result = {
          status: 404,
          type: 'urn:ConfigNotFound',
          title: 'config not found',
          rc: 42404,
        } as ErrorModel
        return HttpResponse.json(result, { status: 404 })
      }
    }

    return HttpResponse.json()
  },
)

export const homepageConfigHandlers = [getHomePageConfig, getPartners]
